module.exports = __webpack_public_path__ + "static/media/0030_Small.4d79ae96.jpg";